<template>
    <AppCommunity />
</template>

<script>
import AppCommunity from '@/components/community/AppCommunity.vue'

export default {
    name: 'ViewCommunity',
    components: {
        AppCommunity
    }
}
</script>